"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledClicker = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const merlin_theme_1 = __importDefault(require("@travelnest/merlin.theme"));
exports.StyledClicker = styled_1.default.div `
	display: flex;
	align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;
    max-width: ${(props) => props.widthOverride};
    border-radius: ${merlin_theme_1.default.layout.spacing.smallest};
	background-color: ${merlin_theme_1.default.colours.neutral.lighter};
	padding: 15px;

	font-family: ${merlin_theme_1.default.typography.fonts.base};
	font-weight: 500;
	font-size: ${merlin_theme_1.default.typography.c1.fontSize};
	color: ${merlin_theme_1.default.colours.neutral.darkest};

    & > button {
		margin: 0;
        border: 0;
		padding: 0;
		height: 40px;
		width: 40px;
        border-radius: 2px;
		background-color: ${merlin_theme_1.default.colours.neutral.light};
    }
`;
//# sourceMappingURL=input-stepper.styled.js.map